import { render, staticRenderFns } from "./ContentRender.vue?vue&type=template&id=3bc505c2&scoped=true&"
import script from "./ContentRender.vue?vue&type=script&lang=ts&"
export * from "./ContentRender.vue?vue&type=script&lang=ts&"
import style0 from "./ContentRender.vue?vue&type=style&index=0&id=3bc505c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc505c2",
  null
  
)

export default component.exports